import api from '@pray/shared/utils/api';

export async function triggerWorkflowAIForEmailOnly({
  artistId = null,
  contentId = null,
  locale = null,
  version = 1,
  type = 'email-only',
  // When a live artifact already exists the server returns 409 unless force is set. The UI only
  // passes force: true after the user confirms "Replace with new draft".
  force = false,
  instructions,
}) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');
  if (!locale) throw Error('Locale is required');

  const normalizedInstructions = instructions?.trim();
  const data = {
    type,
    version,
    force,
    tasks: ['email_campaign'],
    ...(normalizedInstructions ? { instructions: normalizedInstructions } : {}),
  };

  const url = `/web/studio/artists/${artistId}/content/${contentId}/locales/${locale}/workflow-ai`;
  const response = await api.executePostRequest(url, data);

  return response.data.data;
}
